import React, { useState, useEffect } from "react";
import Hero from "../Hero";
import AboutSection from "../Section/AboutSection";
import BrandsSection from "../Section/BrandsSection";
import Banner from "../Section/BannerSection";
import Section from "../Section";
import FeaturesSection from "../Section/FeaturesSection";
import TestimonialSection from "../Section/TestimonialSection";
import BlogSection from "../Section/BlogSection";
import AppointmentSection from "../Section/AppointmentSection";
import FaqSection from "../Section/FaqSection";
import AwardSection from "../Section/AwardSection";
import DepartmentSection from "../Section/DepartmentSection";
import { pageTitle } from "../../helpers/PageTitle";
import PatientProfile from "./patientprofile";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BASE_URL } from "../../helpers/api";
import axios from "axios";
import LoginPopup from "../LoginPopup/LoginPopup"; // ✅ Import reusable LoginPopup

const featureListData = [
  {
    iconSrc: "/images/home_1/compassion.svg",
    title: "Compassion",
    subTitle:
      "We understand that seeking medical care can be a stressful and emotional experience, and we strive to create a welcoming and supportive environment that puts our patients at ease and every one.",
  },
  {
    iconSrc: "/images/home_1/excellence.svg",
    title: "Excellence",
    subTitle:
      "We are committed to providing excellent medical care and services to our patients. We believe in continuously improving our skills, knowledge, and resources to ensure that we deliver the highest quality care possible.",
  },
  {
    iconSrc: "/images/home_1/integrity.svg",
    title: "Integrity",
    subTitle: `We believe in practicing medicine with integrity and honesty. We are transparent in our communication and decision-making processes, and we always put our patient's interests first & provide best solution.`,
  },
  {
    iconSrc: "/images/home_1/respect.svg",
    title: "Respect",
    subTitle:
      "We treat all individuals with respect and dignity, regardless of their background, beliefs, or circumstances. We believe that every person deserves to be treated with compassion and kindness.",
  },
  {
    iconSrc: "/images/home_1/teamwork.svg",
    title: "Teamwork",
    subTitle:
      "We believe in working collaboratively with our team members and other healthcare professionals to provide comprehensive and effective care to our patients.",
  },
];

const brandData = [
  { imgUrl: "images/brand_1.png", imgAlt: "Brand" },
  { imgUrl: "images/brand_2.png", imgAlt: "Brand" },
  { imgUrl: "images/brand_3.png", imgAlt: "Brand" },
  { imgUrl: "images/brand_4.png", imgAlt: "Brand" },
  { imgUrl: "images/brand_5.png", imgAlt: "Brand" },
  { imgUrl: "images/brand_6.png", imgAlt: "Brand" },
  { imgUrl: "images/brand_7.png", imgAlt: "Brand" },
  { imgUrl: "images/brand_8.png", imgAlt: "Brand" },
];

const faqData = [
  {
    title: "What services does Medayus offer?",
    content:
      "Medayus provides online Ayurvedic consultation and family physician services. We offer personalized treatment plans, health guidance, and prescription support. Our goal is to make quality healthcare accessible from the comfort of your home.",
  },
  {
    title: "How do I schedule an appointment with Medayus?",
    content:
      "Booking is simple! Select your preferred date and time on our website, fill in your details, and confirm your slot. You'll receive a confirmation message with all the information you need.",
  },
  {
    title: "Do you accept insurance?",
    content:
      "We currently do not process insurance claims directly. However, we can provide a detailed bill that you may use to request reimbursement from your insurance provider",
  },
  {
    title: "Is Ayurvedic consultation right for me?",
    content:
      "Yes! Ayurveda is a holistic approach to health suitable for all age groups. It focuses on natural healing, lifestyle guidance, and long-term wellness rather than just symptom relief.",
  },
  {
    title: "How do I request a prescription refill?",
    content:
      "You can request a refill by contacting us through our website or patient profile. Our doctor will review your case and send you the updated prescription or next steps as needed",
  },
];

const awardData = [
  {
    title: "Malcolm Baldrige National Quality Award",
    subTitle:
      "This award recognizes healthcare organizations that have demonstrated excellence in leadership, strategic planning, customer and employee satisfaction, and operational efficiency.",
    iconUrl: "images/icons/award.svg",
  },
  {
    title: "HIMSS Davies Award",
    subTitle:
      "This award recognizes healthcare organizations that have used health information technology to improve patient outcomes and reduce costs.",
    iconUrl: "images/icons/award.svg",
  },
  {
    title: "Healthgrades National's Best Hospital",
    subTitle:
      "This recognition is given to hospitals that have achieved high ratings for clinical quality and patient safety across multiple specialties and procedures.",
    iconUrl: "images/icons/award.svg",
  },
  {
    title: "Joint Commission Gold Seal of Approval",
    subTitle:
      "This recognition is given to hospitals that have met rigorous standards for patient safety and quality of care.",
    iconUrl: "images/icons/award.svg",
  },
];

const departmentData = [
  {
    title: "Emergency Department",
    iconUrl: "images/home_1/department_icon_1.svg",
    href: "/departments/emergency",
  },
  {
    title: "Pediatric Department",
    iconUrl: "images/home_1/department_icon_2.svg",
    href: "/departments/pediatric",
  },
  {
    title: "Gynecology Department",
    iconUrl: "images/home_1/department_icon_3.svg",
    href: "/departments/gynecology",
  },
  {
    title: "Cardiology Department",
    iconUrl: "images/home_1/department_icon_4.svg",
    href: "/departments/cardiology",
  },
  {
    title: "Neurology Department",
    iconUrl: "images/home_1/department_icon_5.svg",
    href: "/departments/neurology",
  },
  {
    title: "Psychiatry Department",
    iconUrl: "images/home_1/department_icon_6.svg",
    href: "/departments/psychiatry",
  },
];

export default function Home() {
  pageTitle("Home");

  const [speciality, setSpeciality] = useState("");
  const [date, setDate] = useState(null);
  const [location, setLocation] = useState("");
  const [user, setUser] = useState(null);
  const [locationError, setLocationError] = useState("");
  const [locationsWithSpecialties, setLocationsWithSpecialties] = useState([]);
  const navigate = useNavigate();
  const [latestBlogs, setLatestBlogs] = useState([]);
  const [showLoginPopup, setShowLoginPopup] = useState(false); // ✅ reusable popup state

  // Fetch latest blogs
  useEffect(() => {
    axios.get(`${BASE_URL}/blogs`)
      .then(res => {
        const list = Array.isArray(res.data) ? res.data : [];
        const topThree = list.slice(0, 3);
        const formatted = topThree.map(b => ({
          id: b.id,
          title: b.title,
          image: b.image ? b.image : "/images/blog/default.png",
          created_at: b.created_at,
          socialShare: false,
        }));
        setLatestBlogs(formatted);
      })
      .catch(err => {
        console.log("❌ BLOG FETCH ERROR:", err);
      });
  }, []);

  // Prefill from localStorage
  useEffect(() => {
    const userId = localStorage.getItem("userId") || sessionStorage.getItem("userId");
    if (userId) setUser({ id: userId });

    const storedLocation  = localStorage.getItem("selectedLocation");
    const storedSpeciality = localStorage.getItem("selectedSpeciality");
    const storedDate      = localStorage.getItem("selectedDate");

    if (storedLocation)  setLocation(storedLocation);
    if (storedSpeciality) setSpeciality(storedSpeciality);
    if (storedDate)      setDate(new Date(storedDate));
  }, []);

  // Fetch locations with specialties
  useEffect(() => {
    fetch(`${BASE_URL}/locations-with-specialties`)
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) setLocationsWithSpecialties(data);
        else setLocationsWithSpecialties([]);
      })
      .catch((err) => {
        console.error("Error fetching locations:", err);
        setLocationsWithSpecialties([]);
      });
  }, []);

  // ✅ Intercept footer & navbar "Appointment" link clicks for unauthenticated users
  useEffect(() => {
    const handleAppointmentLinkClick = (e) => {
      const anchor = e.target.closest('a[href="/appointments"]');
      if (!anchor) return;

      const userId = localStorage.getItem("userId") || sessionStorage.getItem("userId");
      const token  = localStorage.getItem("token")  || sessionStorage.getItem("token");

      if (!userId || !token) {
        e.preventDefault();
        e.stopPropagation();
        localStorage.setItem("redirectAfterLogin", "/appointments");
        setShowLoginPopup(true);
      }
    };

    document.addEventListener("click", handleAppointmentLinkClick, true);
    return () => {
      document.removeEventListener("click", handleAppointmentLinkClick, true);
    };
  }, []);

  // Get specialties for the selected location
  const specialties = locationsWithSpecialties.find(
    (loc) => String(loc.location_id) === String(location)
  )?.specialties || [];

  const handleSubmit = (e) => {
    e.preventDefault();
    const userId = localStorage.getItem("userId") || sessionStorage.getItem("userId");
    const token  = localStorage.getItem("token")  || sessionStorage.getItem("token");
    if (!userId || !token) {
      localStorage.setItem("redirectAfterLogin", "/appointments");
      setShowLoginPopup(true);
      return;
    }
    navigate("/appointments");
  };

  return (
    <>
      <Hero
        title="Find the right doctor for your ailments"
        bgUrl="/images/home_1/hero_bg.jpeg"
        imgUrl="/images/home_1/homedocimg.webp"
        videoBtnText="See how we work"
        subTitle=""
        videoUrl="/images/video/clinic-intro.mp4"
        infoList={[
          {
            title: "Location",
            subTitle: (
              <div className="relative">
                <select
                  value={location}
                  onChange={(e) => {
                    setLocation(e.target.value);
                    setLocationError("");
                    setSpeciality("");
                    localStorage.setItem("selectedLocation", e.target.value);
                  }}
                  className="w-full p-2 border rounded text-sm"
                >
                  <option value="">Select Location</option>
                  {locationsWithSpecialties.map((loc) => (
                    <option key={loc.location_id} value={loc.location_id}>
                      {loc.location_name}
                    </option>
                  ))}
                </select>
                {locationError && (
                  <p className="text-blue-500 text-sm font-medium mt-2">
                    {locationError}
                  </p>
                )}
              </div>
            ),
            iconUrl: "/images/icons/pin.svg",
          },
          {
            title: "Speciality",
            subTitle: (
              <select
                value={speciality}
                onChange={(e) => {
                  setSpeciality(e.target.value);
                  localStorage.setItem("selectedSpeciality", e.target.value);
                }}
                className="w-full p-2 border rounded text-sm"
                style={{ width: "200px" }}
              >
                <option value="">Select Speciality</option>
                {specialties.map((spec) => (
                  <option key={spec.id} value={spec.id}>
                    {spec.name}
                  </option>
                ))}
              </select>
            ),
            iconUrl: "/images/contact/first-aid-kit-doctor-svgrepo-com.svg",
          },
          {
            title: "Date",
            subTitle: (
              <DatePicker
                selected={date}
                onChange={(date) => {
                  setDate(date);
                  if (date) {
                    const localDateStr =
                      date.getFullYear() +
                      "-" +
                      String(date.getMonth() + 1).padStart(2, "0") +
                      "-" +
                      String(date.getDate()).padStart(2, "0");
                    localStorage.setItem("selectedDate", localDateStr);
                  }
                }}
                className="w-full p-2 border rounded text-sm"
                placeholderText="Select a date"
                dateFormat="yyyy-MM-dd"
                minDate={new Date()}
              />
            ),
            iconUrl: "/images/icons/date-range.svg",
          },
        ]}
        btnText="Book Now"
        btnUrl="/appointments"
        handleSubmit={handleSubmit}
      />

      <Section>
        <AboutSection
          imgUrl="/images/online-doctor-concept.png"
          spiningImgUrl="/images/home_1/about_mini.svg"
          title="About Us"
          subTitle="Medayus"
          featureList={[
            {
              featureListTitle: "Medayus is led by a dedicated team of doctors",
              featureListSubTitle:
                "Specialized in Ayurvedic Consultation and Family Medicine, offering personalized healthcare that blends traditional wisdom with modern medical practices. At Medayus, we focus on preventive care, natural healing, and long-term wellness solutions tailored to each individual. Whether you seek holistic guidance through Ayurveda or comprehensive care for your family's health needs, our mission is to support your well-being with compassion, trust, and expertise.",
            },
          ]}
        />
      </Section>

      <Section>
        <Banner
          bgUrl="images/home_1/cta_bg.svg"
          imgUrl="images/doctors/doctorsimg3.jpg"
          title="Don't Let Your Health Take a Backseat!"
          subTitle="Take the next step toward better health-schedule your appointment now."
        />
      </Section>

      <Section topMd={90} topLg={45} topXl={45}>
        <BlogSection
          sectionTitle="Latest Update"
          sectionTitleUp="BLOG POSTS"
          data={latestBlogs}
        />
      </Section>

      <Section topMd={190} topLg={145} topXl={105}>
        <FaqSection
          data={faqData}
          sectionTitle="Usually Ask"
          sectionTitleUp="What People"
        />
      </Section>

      {/* ✅ Reusable Login Popup — same design as all other pages */}
      {/* <LoginPopup show={showLoginPopup} redirectPath="/appointments" /> */}
      <LoginPopup 
        show={showLoginPopup} 
        redirectPath="/appointments" 
        onClose={() => setShowLoginPopup(false)} 
      />
    </>
  );
}